<!-- src/views/ResourcesView.html -->
<div class="view-container">
    <div class="header-section">
      <div>
        <h1 class="view-title">Gestione Risorse</h1>
        <p class="view-desc">Censisci e amministra strumenti e postazioni per l'assegnazione nei servizi.</p>
      </div>
      <div class="actions-header">
        <button v-if="activeTab === 'categories'" class="btn-primary rounded-soft" @click="openCatCreate">
          <Plus :size="18" /> Nuova Categoria
        </button>
        <button v-if="activeTab === 'resources'" class="btn-primary rounded-soft" @click="openResCreate">
          <Plus :size="18" /> Nuova Risorsa
        </button>
      </div>
    </div>

    <!-- Tabs Navigation -->
    <div class="tabs-nav border-bottom">
      <button 
        class="tab-btn" 
        :class="{ 'active': activeTab === 'categories' }"
        @click="activeTab = 'categories'"
      >
        <Layers :size="18" />
        Categorie Risorse
      </button>
      <button 
        class="tab-btn" 
        :class="{ 'active': activeTab === 'resources' }"
        @click="activeTab = 'resources'"
      >
        <Box :size="18" />
        Gestione Strumentazioni & Sale
      </button>
    </div>

    <!-- TAB: CATEGORIES -->
    <div v-if="activeTab === 'categories'" class="tab-content">
      <div class="table-container style-surface rounded-soft shadow-soft">
        <table class="data-table">
          <thead>
            <tr>
              <th style="width: 25%">Nome Categoria</th>
              <th style="width: 55%">Descrizione</th>
              <th style="width: 20%; text-align: right;">Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="categories.length === 0">
              <td colspan="3" class="empty-state">Nessuna categoria definita.</td>
            </tr>
            <tr v-for="cat in categories" :key="cat.id" class="row-surface">
              <td class="font-medium text-light">{{ cat.name }}</td>
              <td class="text-muted">{{ cat.description }}</td>
              <td class="actions-cell">
                <button class="btn-icon rounded-soft btn-edit" @click="openCatEdit(cat)" title="Modifica">
                  <Edit :size="16" />
                </button>
                <button class="btn-icon rounded-soft btn-delete" @click="deleteCategory(cat.id)" title="Elimina">
                  <Trash2 :size="16" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- TAB: RESOURCES -->
    <div v-if="activeTab === 'resources'" class="tab-content">

      <!-- Toolbar / Filtro rapido -->
      <div class="filter-bar">
        <label class="text-light font-medium mr-2">Filtra per Categoria:</label>
        <select v-model="resCategoryFilter" class="filter-select rounded-soft">
          <option value="">Tutte le categorie</option>
          <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
        </select>
      </div>

      <div class="table-container style-surface rounded-soft shadow-soft mt-3">
        <table class="data-table table-resource">
          <thead>
            <tr>
              <th style="width: 30%">Risorsa / Strumento</th>
              <th class="hide-mobile" style="width: 20%">Categoria</th>
              <th style="width: 15%">Quantità/Capacità</th>
              <th class="hide-mobile" style="width: 15%; text-align:center;">Disponibilità</th>
              <th style="width: 20%; text-align: right;">Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="filteredResources.length === 0">
              <td colspan="5" class="empty-state">Nessuna risorsa trovata per questa selezione.</td>
            </tr>
            <tr v-for="res in filteredResources" :key="res.id" class="row-surface" :class="{ 'opacity-disabled': !res.isAvailable }">
              <td class="font-medium text-light">
                {{ res.name }}
                <div v-if="!res.isAvailable" class="unavailable-text"><Ban :size="12" /> Non Prenotabile</div>
              </td>
              <td class="hide-mobile">
                <span class="cat-badge">{{ getCategoryName(res.categoryId) }}</span>
              </td>
              <td class="text-light">{{ res.quantity }} pz <span v-if="res.isLowStock" class="badge-danger ml-2" title="Sottoscorta!">⚠️</span></td>
              <td class="hide-mobile" style="text-align:center;">
                <CheckCircle2 v-if="res.isAvailable" class="icon-success" :size="20"/>
                <Ban v-else class="icon-muted" :size="18"/>
              </td>
              <td class="actions-cell">
                <button class="btn-icon rounded-soft btn-edit" @click="openResEdit(res)" title="Modifica">
                  <Edit :size="16" />
                </button>
                <button class="btn-icon rounded-soft btn-delete" @click="deleteResource(res.id)" title="Elimina">
                  <Trash2 :size="16" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>


    <!-- OVERLAYS E DRAWERS -->
    
    <!-- Drawer Categorie -->
    <div 
      class="drawer-overlay" 
      :class="{ 'is-visible': isCatDrawerOpen }"
      @click="closeCatDrawer"
    ></div>
    <div 
      class="drawer"
      :class="{ 'is-open': isCatDrawerOpen }"
    >
      <div class="drawer-header border-bottom">
        <h2>{{ catForm.id === 0 ? 'Nuova Categoria' : 'Modifica Categoria' }}</h2>
        <button class="btn-close" @click="closeCatDrawer">
          <X :size="20" />
        </button>
      </div>
      <div class="drawer-body">
        <form @submit.prevent="saveCategory" id="cat-form">
          <div class="form-group">
            <label for="catName">Nome Categoria *</label>
            <input type="text" id="catName" v-model="catForm.name" required />
          </div>

          <div class="form-group">
            <label for="catDesc">Descrizione</label>
            <textarea id="catDesc" v-model="catForm.description" rows="4"></textarea>
          </div>

          <div v-if="catFormError" class="alert-error mt-3">
            <AlertCircle :size="16" />
            <span>{{ catFormError }}</span>
          </div>
        </form>
      </div>
      <div class="drawer-footer border-top">
        <button type="button" class="btn-secondary rounded-soft" @click="closeCatDrawer">Annulla</button>
        <button type="submit" form="cat-form" class="btn-primary rounded-soft">Salva</button>
      </div>
    </div>

    <!-- Drawer Risorse -->
    <div 
      class="drawer-overlay" 
      :class="{ 'is-visible': isResDrawerOpen }"
      @click="closeResDrawer"
    ></div>
    <div 
      class="drawer"
      :class="{ 'is-open': isResDrawerOpen }"
    >
      <div class="drawer-header border-bottom">
        <h2>{{ resForm.id === 0 ? 'Nuova Risorsa' : 'Modifica Risorsa' }}</h2>
        <button class="btn-close" @click="closeResDrawer">
          <X :size="20" />
        </button>
      </div>
      <div class="drawer-body">
        <form @submit.prevent="saveResource" id="res-form">
          <div class="form-group">
            <label for="resName">Nome Strumentazione / Sala *</label>
            <input type="text" id="resName" v-model="resForm.name" required />
          </div>

          <div class="form-group">
            <label for="resCat">Categoria Risorsa *</label>
            <select id="resCat" v-model="resForm.categoryId" required>
              <option disabled value="0">Seleziona categoria...</option>
              <option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</option>
            </select>
          </div>

          <div class="form-group">
             <label for="resQty">Capacità / Quantità *</label>
             <input type="number" id="resQty" step="1" min="1" v-model="resForm.quantity" required />
          </div>

          <div class="form-group">
            <label for="resMinStock">Soglia Sottoscorta (Minimo) *</label>
            <input 
              type="number" 
              id="resMinStock" 
              v-model="resForm.minStock" 
              min="0" 
              required 
            />
          </div>
          
          <div class="form-group toggle-group mt-3">
            <label class="toggle-label text-light">Disponibile per prenotazione?</label>
            <label class="switch">
              <input type="checkbox" v-model="resForm.isAvailable">
              <span class="slider round"></span>
            </label>
          </div>

          <div class="form-group mt-3">
            <label for="resNotes">Note Tecniche</label>
            <textarea id="resNotes" v-model="resForm.notes" rows="4"></textarea>
          </div>

          <div v-if="resFormError" class="alert-error mt-3">
            <AlertCircle :size="16" />
            <span>{{ resFormError }}</span>
          </div>
        </form>
      </div>
      <div class="drawer-footer border-top">
        <button type="button" class="btn-secondary rounded-soft" @click="closeResDrawer">Annulla</button>
        <button type="submit" form="res-form" class="btn-primary rounded-soft">Salva Risorsa</button>
      </div>
    </div>


  </div>
